// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_task__s5fd5 {
  display: flex;
  width: 100%;
  align-items: center;
}
.style_task__filled__w9bUs {
  background: rgb(117, 83, 240);
  border-radius: 20px;
  padding: 16px;
}
.style_task__left__T28gD {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 3 1;
}
.style_task__icon__g5bPn {
  width: 24px;
  font-size: 16px;
  color: rgb(117, 83, 240);
}
.style_task__icon__filled__OmmnM {
  color: rgb(255, 255, 255);
}
.style_task__content__XpgBm {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.style_task__content__title__68DFe {
  color: rgb(27, 27, 27);
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 150%;
  max-width: 190px;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.style_task__content__subtitle__ao6sp {
  color: rgb(27, 27, 27);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  gap: 6px;
  align-items: center;
}
.style_task__content__subtitle__ao6sp img {
  width: 12px;
  height: 12px;
}
.style_task__right__vEjCz {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.style_faded__Fvx6p {
  opacity: 0.5;
}

.style_white__yKUjx {
  color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/pages/earn/tasks/task-item/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AADF;AAGE;EACE,6BCRG;EDSH,mBAAA;EACA,aAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AAFJ;AAKE;EACE,WAAA;EACA,eAAA;EACA,wBCvBG;ADoBP;AAII;EACE,yBCpBE;ADkBR;AAME;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAJJ;AAMI;EACE,sBCjCQ;EDkCR,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAOI;EACE,sBC7CQ;ED8CR,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AALN;AAMM;EACE,WAAA;EACA,YAAA;AAJR;AASE;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,yBCtEM;AD8DR","sourcesContent":["@import 'public/assets/colors';\n\n.task {\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  &__filled {\n    background: $main;\n    border-radius: 20px;\n    padding: 16px;\n  }\n\n  &__left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 3;\n  }\n\n  &__icon {\n    width: 24px;\n    font-size: 16px;\n    color: $main;\n    &__filled {\n      color: $white;\n    }\n  }\n\n  &__content {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n\n    &__title {\n      color: $black-extra;\n      font-size: 1.3rem;\n      font-weight: 600;\n      line-height: 150%;\n      max-width: 190px;\n      text-align: start;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &__subtitle {\n      color: $black-extra;\n      font-size: 1.2rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 150%;\n      display: flex;\n      gap: 6px;\n      align-items: center;\n      img {\n        width: 12px;\n        height: 12px;\n      }\n    }\n  }\n\n  &__right {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n}\n\n.faded {\n  opacity: 0.5;\n}\n\n.white {\n  color: $white;\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"task": `style_task__s5fd5`,
	"task__filled": `style_task__filled__w9bUs`,
	"task__left": `style_task__left__T28gD`,
	"task__icon": `style_task__icon__g5bPn`,
	"task__icon__filled": `style_task__icon__filled__OmmnM`,
	"task__content": `style_task__content__XpgBm`,
	"task__content__title": `style_task__content__title__68DFe`,
	"task__content__subtitle": `style_task__content__subtitle__ao6sp`,
	"task__right": `style_task__right__vEjCz`,
	"faded": `style_faded__Fvx6p`,
	"white": `style_white__yKUjx`
};
export default ___CSS_LOADER_EXPORT___;
